import { Theme } from '@mui/material';
import { adjustFontSize } from '@theme/styleOverrides/typography';

// TODO combine dark styles with light styles, extend theme

const selectStyles = ({ palette }: Theme) =>
  ({
    '& .MuiSelect-root': {
      color: palette.text.subdued,
    },

    '&.MuiOutlinedInput-root': {
      fieldset: {
        borderWidth: '1px',
        borderColor: palette.text.subdued,
        borderRadius: (theme: Theme) => theme.shape.borderRadius,
      },
      '&:hover': {
        '& > fieldset': {
          borderColor: palette.text.main,
        },
      },
      '&.Mui-focused': {
        '& > fieldset': {
          borderWidth: '2px',
          borderColor: palette.secondary.main,
        },
      },
      '&.Mui-error': {
        '& > fieldset': {
          borderColor: palette.error.main,
        },
        '& .MuiSelect-icon': {
          color: palette.text.main,
        },
      },
      '&.Mui-disabled': {
        '& > fieldset': {
          borderColor: palette.text.disabled,
        },
        '& .MuiSelect-icon': {
          color: palette.text.disabled,
        },
        '& .MuiOutlinedInput-input': {
          WebkitTextFillColor: palette.text.disabled,
        },
      },
    },

    '& .MuiSelect-icon': {
      color: palette.text.subdued,
      width: '10px',
      height: '6px',
      right: '12px',
      top: 'auto',
    },
  }) as const;

const menuLabel = {
  '&.MuiMenuItem-root': {
    cursor: 'pointer',
    pointerEvents: 'auto',
    '&.Mui-disabled': {
      opacity: 1,
    },
  },
} as const;

const floatingLabel = ({ palette }: Theme) =>
  ({
    '&.MuiFormLabel-root.MuiInputLabel-root': {
      color: palette.text.subdued,
      lineHeight: '20px',
      fontSize: ({ palette }: Theme) => `${adjustFontSize(14, palette.fontSize)}px`,
      transform: 'translateX(12px) translateY(10px)',
      padding: '0px',
      '&.Mui-focused': {
        transform: 'translateX(12px) translateY(-9px) scale(.92)',
        transformOrigin: 'left',
        fontSize: ({ palette }: Theme) => `${adjustFontSize(12, palette.fontSize)}px`,
        color: palette.secondary.main,
      },
    },
  }) as const;

const hasSelection = ({ palette }: Theme) =>
  ({
    '&.MuiFormLabel-root.MuiInputLabel-root': {
      color: palette.text.subdued,
      fontSize: ({ palette }: Theme) => `${adjustFontSize(12, palette.fontSize)}px`,
      transform: 'translateX(12px) translateY(-9px) scale(.92)',
      transformOrigin: 'left',
    },

    '& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input': {
      padding: '12px 32px 4px 12px',
      color: palette.text.main,
    },
  }) as const;

const isDisabled = {
  '&.MuiFormLabel-root.MuiInputLabel-root': {
    color: ({ palette }: Theme) => palette.text.disabled,
  },
} as const;

const staticLabel = {
  '& .MuiFormLabel-root.MuiInputLabel-root': {
    position: 'relative',
    fontSize: ({ palette }: Theme) => `${adjustFontSize(12, palette.fontSize)}px`,
    margin: '0 0 2px 0',
    transform: 'initial',
    zIndex: '0',
  },
} as const;

const fullWidth = {
  '&.MuiFormControl-root': {
    width: '100%',
    '& .MuiInputBase-root': {
      width: '100%',
    },
  },
} as const;

export { selectStyles, floatingLabel, fullWidth, hasSelection, isDisabled, menuLabel, staticLabel };
